<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <h1>User Profile</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        {{ userInfo }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import authentication from "../authentication";
export default {
  name: "UserProfile",
  data() {
    return {};
  },
  computed: {
    userInfo() {
      return authentication.getUserProfile();
    },
  },
  mounted() {},
};
</script>